import { useQuery } from "@tanstack/react-query";
import { getCompanies } from "../getCompanies";
import { queryKeys } from "../queryKeys";

export default function useCompanies() {
  const { data: companies } = useQuery({
    queryKey: [queryKeys.companies],
    queryFn: getCompanies,
  });
  return companies;
}
